import { useState } from 'react';
import './contact.component.css';

export const ContactSlide = ({
    onSubmit
}: {
    onSubmit: ({ name, lastName, email, phone }: { name: string; lastName: string; email: string; phone: string }) => Promise<void>;
}) => {
    // State
    const [consent, setConsent] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [formState, setFormState] = useState({
        name: '',
        lastName: '',
        email: '',
        phone: ''
    });

    // Handlers
    const handleInputChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        setFormState({
            ...formState,
            [e.target.name]: e.target.value
        })
    }
    const handleSubmit: React.FormEventHandler<HTMLFormElement> = (e) => {
        e.preventDefault();
        setSubmitting(true)
        onSubmit(formState).then(() => {
            setSubmitting(false);
        });
    }

    return (<div className="contact row">
        <div className="col-6">
            <h2>
                Por último, introduce tus <span className="inverted">datos de contacto.</span>
            </h2>
            <hr className="separator green-gradient"></hr>
            <p className="p-large">
                Nos pondremos en contacto con un estudio y presupuesto detallado de tu instalación.
            </p>
        </div>
        <div className="col-6">
            <form className="stylized-form" onSubmit={handleSubmit}>
                <div className="fake-input">
                    <img src={require('../../assets/name.png')} alt="Nombre" />
                    <input name="name" type="text" onChange={handleInputChange} placeholder="Nombre" required />
                </div>
                <div className="fake-input">
                    <img src={require('../../assets/last-name.png')} alt="Apellidos" />
                    <input name="lastName" type="text" onChange={handleInputChange} placeholder="Apellidos" required />
                </div>
                <div className="fake-input">
                    <img src={require('../../assets/email.png')} alt="E-mail" />
                    <input name="email" type="email" onChange={handleInputChange} placeholder="E-mail" required />
                </div>
                <div className="fake-input">
                    <img src={require('../../assets/phone.png')} alt="Teléfono" />
                    <input name="phone" type="tel" onChange={handleInputChange} placeholder="Teléfono" required />
                </div>
                <button disabled={!consent || submitting} type="submit" className="button">
                    Enviar
                </button>
                <label className="checkbox">
                    <input type="checkbox" onChange={() => { setConsent(!consent); }} />
                    Consiento el tratamiento de mis datos. <a href="#">Leer más</a>
                </label>
            </form>
        </div>
    </div>);
}